import React, {Component} from 'react';
import { Button, Form, Message } from 'semantic-ui-react'
import {client} from '../../Client';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import Moment from 'moment'
import {Redirect} from 'react-router-dom';
import 'react-date-picker/index.css'
import {convertNullToEmptyString, renderElapsedString} from '../../Helpers'
import TestiEditDropdown from '../TestiEditDropdown'
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage'

class AttivitaRunningExt extends Component {
    constructor(props) {
        super(props);

        this.state = {
            oraFineAutomatica: true, // Diventa false quando viene modificata a mano
            elapsed: 0,
            fields: this.getFieldsFormItem(props.item, props.fine),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
            dropdownNotaLoading: false,
        };
        this.onChange = this.onChange.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onOraAttualeClick = this.onOraAttualeClick.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.onDDNotaLoading = this.onDDNotaLoading.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.salvaNota = this.salvaNota.bind(this)
        this.setOraFine = this.setOraFine.bind(this)
    }

    getFieldsFormItem(item, fine) {
        let fields = convertNullToEmptyString(item);
        let oraAttuale = Moment().format("HH:mm");
        let oraInizio = Moment(fields.inizio).format("HH:mm");
        if (fine !== undefined){
            fields.fine = fine;
        }
        else if (oraAttuale > oraInizio) {
            fields.fine = oraAttuale;
        }
        else
        {
            fields.fine =  Moment(fields.inizio).add(1, "minute").format("HH:mm");
        }
        return fields;

    }

    componentWillReceiveProps(nextProps, nextContext){

        if (nextProps.item !== this.props.item){
            this.setState({fields: this.getFieldsFormItem(nextProps.item, nextProps.fine)})
        }
        if (nextProps.fine !== this.props.fine){
            this.setOraFine(nextProps.fine, false);
        }
    }

    componentDidMount() {
        this.forceUpdateInterval = setInterval(() => this.updateTime(), 50);
    }

    componentWillUnmount() {
        clearInterval(this.forceUpdateInterval);
    }

    updateTime(){
        let oraAttuale = Moment().format("HH:mm");
        let oraInizio = Moment(this.state.fields.inizio).format("HH:mm");
        if (oraAttuale < oraInizio){
            oraAttuale = Moment(this.state.fields.inizio).add(1, "minute").format("HH:mm");
        }
        //console.log("ora fine/ auto:", this.props.fine, this.state.oraFineAutomatica);
        if (this.state.oraFineAutomatica === true && oraAttuale !== this.state.fields.fine){
            let fields = Object.assign({}, this.state.fields);
            fields["fine"] = oraAttuale;
            this.setState({fields})
        }
        else {
            this.forceUpdate();
        }
    }

    onChange() {
        if (this.props.onChange)
        {
            this.props.onChange();
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (this.state.fields.fine === undefined )
        {
            fieldErrors["fine"] = true;
            fieldErrorsText.push("Occorre specificare l'ora di fine di questa attività");
        }
        let oraInizio = Moment(this.state.fields.inizio).format('HH:mm');
        if (this.state.fields.fine !== undefined &&  this.state.fields.fine < oraInizio)
        {
            fieldErrors["fine"] = true;
            fieldErrorsText.push("Occorre specificare un'ora di fine uguale o successiva a quella di inizio: " + oraInizio);
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            let prevValue = fields[name];
            fields[name] = value;
            if (name === 'fine'){

                if (value.length === 2 && !value.includes(':')){
                    if (prevValue.length === 3 && prevValue.includes(':')){
                        fields[name] = '';
                    }
                    else
                    {
                        fields[name] += ':';
                    }
                }

                this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false, oraFineAutomatica: false });
            }
            else
            {
                this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
            }

        }
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = Object.assign({}, this.state.fields);

        // Validazione form
        if (!this.formIsValid(this.state.fields)){
            return;
        }

        let oraInizio = Moment(formData["inizio"]).format("HH:mm");
        formData["inizio"] = this.props.giorno + " " + oraInizio;

        let oggiStr = Moment().format('YYYY-MM-DD');
        let ieriStr = Moment().subtract(1, 'days').format('YYYY-MM-DD');

        if (this.props.giorno === ieriStr && formData["fine"] < oraInizio){
            formData["fine"] = oggiStr + " " + formData["fine"];
        }
        else
        {
            formData["fine"] = this.props.giorno + " " + formData["fine"];
        }

        formData["giorno"] = this.props.giorno ;
        formData["idCommessa"] = this.state.fields.idCommessa.idCommessa;
        formData["idUtente"] = this.state.fields.idUtente.idUtente;

        this.setState({_loading: true});
        client.saveAttivita(
            formData, this.state.fields.idAttivita
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        // saveSuccess: true,
                        // attivitaSaved: data,
                    });
                    this.onChange();
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message, "Rieseguire il login e riprovare."],
                errorTitle: "Errore di rete imprevisto: probabile accesso non autorizzato",
                inError: true
            });
        });
    }

    salvaNota(ev){
        ev.preventDefault();
        let formData = Object.assign({}, this.state.fields);

        // Validazione form
        if (!this.formIsValid(this.state.fields)){
            return;
        }
        formData["inizio"] = this.props.giorno + " " + Moment(formData["inizio"]).format("HH:mm");
        formData["fine"] = '';
        formData["idCommessa"] = this.state.fields.idCommessa.idCommessa;
        formData["idUtente"] = this.state.fields.idUtente.idUtente;

        this.setState({_loading: true});
        client.saveAttivita(
            formData, this.state.fields.idAttivita
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onDeleteClick(){

    }

    isLoadingInProgress(){
        return this.state._loading || this.state.dropdownNotaLoading;
    }

    onDDNotaLoading(value){
        this.setState({dropdownNotaLoading: value})
    }

    setOraFine(ora, automatica = true){
        let fields = Object.assign({}, this.state.fields);
        fields["fine"] = ora;
        this.setState({fields, oraFineAutomatica: automatica})
    }

    onOraAttualeClick(ev) {
        ev.preventDefault();
        this.setOraFine(Moment().format("HH:mm"));
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/attivita',
                state: {
                    from: this.props.location,
                    item: this.state.attivitaSaved,
                },
            }}/>
        }

        let oraFine = Moment(this.props.giorno + " " + Moment().format("HH:mm:ss"));
        if (this.props.elapsedTimeFromNow === false){
            oraFine = Moment(this.props.giorno + " " + Moment(this.props.giorno + " " +this.state.fields.fine).format("HH:mm"));
        }

        const elapsedString = renderElapsedString(this.props.item.inizio, oraFine, this.props.elapsedTimeFromNow);
        let tempoTrascorso = null;
        if (elapsedString !== ''){
            tempoTrascorso = (
                <div className="ui one statistics">
                    <div className="ui large statistic">
                        <div className="value">
                            <i className="clock icon"></i>{elapsedString}
                        </div>
                        <div className="label">
                            Tempo trascorso
                        </div>
                    </div>
                </div>
            )

            tempoTrascorso = (
                <span>
                    - Tempo trascorso
                    <div className="ui tiny horizontal statistic" style={{marginLeft: "10px"}}>
                    <div className="value">
                        {elapsedString}
                    </div>
                </div>
                </span>
            )

        }



        return <div>
            <table className="ui table">
                <tbody>
                <tr>
                    <td>
            <h3><label className="ui empty circular label" style={{backgroundColor: this.props.item.idCommessa.colore, marginRight: "5px"}}></label>{this.props.item.idCommessa.codice} {this.props.item.idCommessa.nome} - Avvio il <b><LocalDate data={this.props.giorno} inline /></b> ore <LocalTime data={this.props.item.inizio} /> {tempoTrascorso}</h3>

            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>
                <div className="ui stacked grid">
                    <div className="eight wide column">
                        <TestiEditDropdown tipo="ATTNT" name='nota' additionLabel='Nuova nota: '
                                           placeholder="Note..."
                                           maxlength={255}
                                           value={''+this.state.fields.nota}
                                           error={this.state.fieldErrors["nota"]}
                                           onChange={this.onInputChange}
                                           onLoading={this.onDDNotaLoading}
                        />

                        {/*<TestiDropdown tipo="ATTNT" name='nota' additionLabel='Note: ' placeholder="Note..."*/}
                                       {/*maxlength={255}*/}
                                       {/*value={''+this.state.fields.nota}*/}
                                       {/*error={this.state.fieldErrors["nota"]}*/}
                                       {/*onChange={this.onInputChange}*/}
                                       {/*onLoading={this.onDDNotaLoading}*/}
                        {/*/>*/}
                    </div>
                    <div className="eight wide column">
                        <Form.Field width={4}>

                            <Form.Group inline>
                                <label>Peso</label>
                                <Form.Input style={{width:"50px"}}  name='peson' min="1" max="10" placeholder='' autoComplete="nope"  value={this.state.fields.peson} onChange={this.onInputChange}/>&nbsp;/&nbsp;&nbsp;
                                <Form.Input style={{width:"50px"}} name='pesod' min="1" max="10" placeholder='' autoComplete="nope"  value={this.state.fields.pesod} onChange={this.onInputChange}/>
                                <Button className="button icon" style={{textAlign: "left"}} loading={this.isLoadingInProgress()} onClick={this.salvaNota} title="Salva la nota sull'attività corrente"><i className="save icon"/> </Button>
                            </Form.Group>
                        </Form.Field>
                    </div>
                    <div className="sixteen wide column">
                        <Form.Group inline>
                            <Form.Input label='Ora fine' name='fine' style={{width: "80px"}} pattern="^[0-2][0-9]:[0-5][0-9]$" autoComplete="nope" required={true}  value={this.state.fields.fine} error={this.state.fieldErrors["fine"]} onChange={this.onInputChange}/>
                            <Button loading={this.isLoadingInProgress()} onClick={this.onOraAttualeClick}><i className="clock icon"/> Ora attuale</Button>
                            <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="stop icon"/> Stop</Button>
                            <Button className="red right floated" loading={this.isLoadingInProgress()} onClick={(ev) => (this.props.onDeleteClick(ev, this.props.item))}><i className="trash icon"/> Elimina</Button>
                        </Form.Group>

                    </div>
                </div>

                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />
            </Form>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    }
}

AttivitaRunningExt.PropTypes = {
    item: PropTypes.object.isRequired,
    giorno: PropTypes.string.isRequired,
    fine: PropTypes.string.isRequired,
    onDeleteClick: PropTypes.func,
    elapsedTimeFromNow: PropTypes.bool.isRequired,
}

export default AttivitaRunningExt;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaRunningExt.jsx
 **/